import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { map } from 'rxjs';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root',
})
export class MarketService {
  constructor(
    private readonly http: HttpClient,
  ) {
  }

  public getApplications() {
    return this.http.get<any>(environment.baseURL + '/application')
      .pipe(map(v => v.data));
  }

  public install(application_id: string) {
    return this.http.post<any>(environment.baseURL + `/application/install/${application_id}`, {})
      .pipe(map(v => v.data));
  }

  public uninstall(application_id: string) {
    return this.http.post<any>(environment.baseURL + `/application/uninstall/${application_id}`, {})
      .pipe(map(v => v.data));
  }

}
